import React from 'react';
import { Row } from 'react-bootstrap';
import ServiceItem from './ServiceItem';
import { connect } from 'react-redux';
import { certifixPhoneWithCountryCode, noServicesAvailableMessage, supportEmail } from '../utils/confirmationMessage';
import Loader from './shared/loader/Loader';


const Services = ({ allowedOrderTypes, isLoading }) => {
  let services = [];
  if (allowedOrderTypes) {
    services = Object.keys(allowedOrderTypes).map(key => {

      const service = {
        orderTypeId: allowedOrderTypes[key].Id,
        serviceId: allowedOrderTypes[key].Setting.Id,
        title: allowedOrderTypes[key].Setting.Value.title,
        subHeader: allowedOrderTypes[key].Setting.Value.description,
        route: allowedOrderTypes[key].Uri
      }
      return service;
    })
  }


  return (
    <div className='services-container'>

      <div className='service-selection'>
        {(isLoading) && <Loader />}
        {!isLoading && allowedOrderTypes && (
          <Row className="mb-4">
            {
              services.length > 0 ? services.map(service => {
                return (
                  <ServiceItem key={service.orderTypeId} service={service} />
                )
              }) : <div className='no-services-container'>
                <div>{noServicesAvailableMessage('messageOne')}</div>
                <div>{noServicesAvailableMessage('messageTwo')}</div>
                <div> {noServicesAvailableMessage('messageThree')}
                  <a id="telNum" href={`tel:${certifixPhoneWithCountryCode()}`}> {certifixPhoneWithCountryCode()}</a>
                  or  <a href={`mailto:${supportEmail()}`}>{supportEmail()}</a>
                  {noServicesAvailableMessage('messageFour')}</div>
              </div>
            }
          </Row>)}
      </div>
    </div>

  )
}

function mapStateToProps({ allowedOrderTypes, isLoading }) {
  return {
    allowedOrderTypes,
    isLoading
  }
}
export default connect(mapStateToProps)(Services)
